// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file voucher/types/v1/usage.proto (package voucher.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Money } from "../../../types/v1/money_pb.js";

/**
 * @generated from message voucher.types.v1.Discount
 */
export const Discount = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.Discount",
  () => [
    { no: 1, name: "target", kind: "enum", T: proto3.getEnumType(Discount_Target) },
    { no: 2, name: "fixed_amount", kind: "message", T: Money, oneof: "typ" },
    { no: 3, name: "percentage", kind: "message", T: Discount_Percentage, oneof: "typ" },
  ],
);

/**
 * @generated from enum voucher.types.v1.Discount.Target
 */
export const Discount_Target = /*@__PURE__*/ proto3.makeEnum(
  "voucher.types.v1.Discount.Target",
  [
    {no: 0, name: "TARGET_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TARGET_ORDER", localName: "ORDER"},
    {no: 2, name: "TARGET_LINE_ITEM", localName: "LINE_ITEM"},
  ],
);

/**
 * @generated from message voucher.types.v1.Discount.Percentage
 */
export const Discount_Percentage = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.Discount.Percentage",
  () => [
    { no: 1, name: "percent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "upper_limit", kind: "message", T: Money, opt: true },
  ],
  {localName: "Discount_Percentage"},
);

/**
 * @generated from message voucher.types.v1.UsageRestriction
 */
export const UsageRestriction = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.UsageRestriction",
  () => [
    { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(UsageRestriction_RestrictionType) },
    { no: 7, name: "max_usage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from enum voucher.types.v1.UsageRestriction.RestrictionType
 */
export const UsageRestriction_RestrictionType = /*@__PURE__*/ proto3.makeEnum(
  "voucher.types.v1.UsageRestriction.RestrictionType",
  [
    {no: 0, name: "RESTRICTION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RESTRICTION_TYPE_TOTAL", localName: "TOTAL"},
    {no: 2, name: "RESTRICTION_TYPE_SERIES", localName: "SERIES"},
    {no: 3, name: "RESTRICTION_TYPE_EVENT", localName: "EVENT"},
    {no: 4, name: "RESTRICTION_TYPE_PRICE", localName: "PRICE"},
  ],
);

/**
 * @generated from message voucher.types.v1.LineItem
 */
export const LineItem = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.LineItem",
  () => [
    { no: 1, name: "series_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bundle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message voucher.types.v1.Usage
 */
export const Usage = /*@__PURE__*/ proto3.makeMessageType(
  "voucher.types.v1.Usage",
  () => [
    { no: 1, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "used_total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

